import { registerSW } from 'virtual:pwa-register';

let updateSW: ((reloadPage?: boolean) => Promise<void>) | undefined;

async function clearStalePwaCaches() {
  if (!('caches' in window)) return;
  const keys = await caches.keys();
  await Promise.all(keys.filter((k) => k === 'pages').map((k) => caches.delete(k)));
}

export function initPwaUpdates(onAvailable: () => void) {
  void clearStalePwaCaches();
  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      onAvailable();
    },
    onRegisteredSW(_swUrl, registration) {
      registration?.update().catch(() => {});
    },
  });
}

export async function applyPwaUpdate() {
  if (updateSW) await updateSW(true);
  else window.location.reload();
}
